/**
 * Module: Feedback API
 * SpecReferenceID: GALEN-CHAT-V1
 * Requirements: GALEN-CHAT-V1-R12
 *
 * Submits structured user feedback to the dedicated POST /v1/feedback
 * endpoint instead of piping through search usage tracking.
 *
 * GALEN-CHAT-V1-R12: Capture usage and conversation metrics.
 */

import api from '@/lib/api';

export interface FeedbackRequest {
  conversation_id?: string | null;
  message_id?: string | null;
  rating: 'up' | 'down';
  comment?: string | null;
}

/**
 * Submit feedback to the dedicated feedback endpoint.
 * Silently fails so feedback submission never interrupts UX.
 */
export async function submitFeedback(data: FeedbackRequest): Promise<void> {
  try {
    await api.post('/feedback', {
      conversation_id: data.conversation_id ?? undefined,
      message_id: data.message_id ?? undefined,
      rating: data.rating,
      comment: data.comment ?? undefined,
    });
  } catch {
    // Silently fail - feedback submission should not interrupt UX
    console.debug('Feedback submission failed');
  }
}
